"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRICE_MOBILE = exports.PRICE = exports.DIRECTION = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DIRECTION = exports.DIRECTION = {
  decreased: 'decreased',
  increased: 'increased'
};
var PRICE_MOBILE = exports.PRICE_MOBILE = {
  increased: {
    title: 'Похоже, цена на тур \nтолько что изменилась',
    description: 'Такое бывает из-за повышенного спроса в отель. Вы можете купить тур \nпо финальной цене или посмотреть другие туры в этот отель',
    buttonText: 'Купить'
  },
  decreased: {
    title: 'Вот это да! Тур подешевел\nпока вы заполняли данные',
    description: 'Платёж будет произведён по новой,\nболее низкой, цене',
    buttonText: 'Купить'
  }
};
var PRICE = exports.PRICE = {
  decreased: PRICE_MOBILE.decreased,
  increased: _objectSpread(_objectSpread({}, PRICE_MOBILE.increased), {}, {
    buttonText: 'Продолжить оплату\n'
  })
};